import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const actions = createActions(
  {
    COMPANY_MODAL_VALIDATE_EMAIL: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    COMPANY_MODAL_VALIDATE_PHONE_NUMBER: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    COMPANY_MODAL_UPDATE_COMPANY: [
      (payload: any) => payload, // Payload
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    COMPANY_MODAL_ADD_COMPANY: [
      (payload: any) => payload, // Payload
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
  },

  'COMPANY_MODAL_GET_USERS',
  'COMPANY_MODAL_GET_USERS_RESULT',

  'COMPANY_MODAL_VALIDATE_EMAIL_RESULT',
  'COMPANY_MODAL_VALIDATE_PHONE_NUMBER_RESULT',

  'COMPANY_MODAL_SHOW',
  'COMPANY_MODAL_HIDDEN',

  'COMPANY_MODAL_OPEN_AVATAR_CROPPER_FILE_CHANGE',

  'COMPANY_MODAL_CLOSE_AVATAR_CROPPER',

  'COMPANY_MODAL_UPDATE_COMPANY_SUCCEEDED',
  'COMPANY_MODAL_UPDATE_COMPANY_FAILED',

  'COMPANY_MODAL_UPDATE_COMPANY_AVATAR_RESULT',

  'COMPANY_MODAL_ADD_COMPANY_SUCCEEDED',
  'COMPANY_MODAL_ADD_COMPANY_FAILED',

  'COMPANY_MODAL_AVATAR_IMAGE_HANDLE_CROP',

  'COMPANY_MODAL_AVATAR_UPLOAD_SUCCEEDED',
  'COMPANY_MODAL_AVATAR_UPLOAD_FAILED',

  'COMPANY_MODAL_GET_PRESIGNED_URL',
  'COMPANY_MODAL_GET_PRESIGNED_URL_SUCCEEDED',
  'COMPANY_MODAL_GET_PRESIGNED_URL_FAILED',
);
